module.exports = __webpack_public_path__ + "static/media/bags2.88c14b0c.jpg";